// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"BlockingProgress_backdrop__2sfu8","paper":"BlockingProgress_paper__11Ghi"};